import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import Logo from '../assets/images/logo-new-name.png';
import {  AiOutlineTwitter , AiFillLinkedin} from 'react-icons/ai';

const Footer = () => (
  <Box mt="80px" bgcolor="#FFF3F4">
    <Stack gap="40px" sx={{ alignItems: 'center' }} flexWrap="wrap" px="40px" pt="24px">

      <img src={Logo} alt="logo" style={{ width: '200px', height: '120px' }} />
      
    </Stack>

    <Typography variant="h5" sx={{ fontSize: { lg: '28px', xs: '20px' } }} mt="5px" textAlign="center" pb="40px">Made by <a href="https://www.linkedin.com/in/som-kamoji-83220519b/">Som Kamoji</a></Typography>
      
      
    
  </Box>
);

export default Footer;